// extracted by mini-css-extract-plugin
export default {"root":"EditableSectionCard_root__3cozw","title":"EditableSectionCard_title__Fv37Q","readOnlyButton":"EditableSectionCard_readOnlyButton__1lfG6"};